<template>
  <div class="col-lg-12">

    <b-collapse id="filters" class="p-2">
      <b-row>
        <b-col lg="3">
          <search @updateFilter="setRouterQuery"/>
        </b-col>
        <b-col lg="3">
          <product-type @updateFilter="setRouterQuery"/>
        </b-col>
        <b-col lg="3">
          <quantity @updateFilter="setRouterQuery"/>
        </b-col>
        <b-col lg="3">
          <per-page @updateFilter="setRouterQuery"/>
        </b-col>
        <b-col v-if="isAdmin">
          <multiple-store class="my-2" @updateFilter="setRouterQuery"/>
        </b-col>
        <b-col lg="3">
          <brand @updateFilter="setRouterQuery"/>
        </b-col>
        <b-col>
          <category @updateFilter="setRouterQuery"/>
        </b-col>

      </b-row>
    </b-collapse>

  </div>
</template>

<script>
import Search from "./Filters/Search";
import ProductType from "./Filters/ProductType";
import Quantity from "./Filters/Quantity";
import PerPage from "./Filters/PerPage";
import Brand from "./Filters/Brand";
import Category from "./Filters/Category/Category";
import MultipleStore from "./Filters/MultipleStore";
import {mapGetters} from "vuex";

export default {
  name: "Filters",
  components: {Search, ProductType, Quantity, PerPage, Brand, Category, MultipleStore,},
  computed: {
    ...mapGetters({
      isAdmin: "User/isAdmin"
    })
  },
  methods: {
    setRouterQuery(value) {
      const valueKey = Object.keys(value)[0]
      if (['brand', 'category'].indexOf(valueKey) > -1) {
       value[valueKey] = value[valueKey].map(item=>item.id).join(',')
      }
      console.log(value)
      const currentRouteQuery = this.$route.query
      this.$router.push({name: this.$route.name, query: {...currentRouteQuery, ...value}})
    }
  }
}
</script>

<style scoped>

</style>